import BaseInput from "@/components/reusables/BaseInput";
import BaseIntegrationIcon from "@reusables/BaseIntegrationIcon";
import { isSystemIntegratedSelector } from "@/redux/features/auth/authSlice";
import { useAppSelector } from "@/redux/hooks";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ProductType } from "../../../types";

type SupplierProductCodeFieldProps = {
    editing?: boolean;
};

/**
 * Supplier Product Code is a secondary identifier to be used in 24SevenOffice (Finago). It is optional and only available if the integration is enabled.
 */
export default function SupplierProductCodeField({
    editing = false,
}: SupplierProductCodeFieldProps) {
    const { t } = useTranslation("", { keyPrefix: "products.general" });

    const { control } = useFormContext<ProductType>();

    const isTwentyFourSevenOfficeEnabled = useAppSelector(
        isSystemIntegratedSelector("twenty_four_seven_office")
    );

    if (!isTwentyFourSevenOfficeEnabled) return null;

    return (
        <Controller
            name="twenty_four_seven_office.supplier_code"
            control={control}
            render={({ field, fieldState }) => (
                <BaseInput
                    {...field}
                    error={fieldState.error}
                    label={
                        <div className="font-semibold flex items-center space-x-2">
                            <BaseIntegrationIcon integration="twenty_four_seven_office" />
                            <span>{t("fields.supplierProductCode")}</span>
                        </div>
                    }
                    disabled={editing}
                />
            )}
        />
    );
}
